module.exports = __webpack_public_path__ + "img/cascadia-code-dark.8e4b0f25.png";